export const types = {
  HIGHLIGHT_ELEMENTS: 'HIGHLIGHT_ELEMENTS'
}



// WEBPACK FOOTER //
// ./src/features/app/store/types.js